/*       */

import React from 'react';
import styled from 'styled-components';

const FullWidthStyled = styled.div`
    width: 100%;
`;

const Group = React.memo(({ children, ...divProps }) => {
    return <FullWidthStyled {...divProps}>{children}</FullWidthStyled>;
});

export default Group;
